import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import TrustedNumberConfirmationModal from '../../components/security/TrustedNumberConfirmationModal';
import { toggleUpdateTrustedNumberModal } from '../../actions/AppActions';
import { setup } from '../../actions/security/SecurityPhoneNumberActions';
import { getIsUpdateTrustedNumberModal } from '../../selectors/InteractionSelector';
import { updateTrustedPhoneNumberKey } from '../../constants/security/TrustedNumberModalKeys';
import { jsx as _jsx } from "react/jsx-runtime";
class UpdateTrustedNumberModalContainer extends Component {
  render() {
    if (this.props.updateTrustedNumberModalOpen) {
      return /*#__PURE__*/_jsx(TrustedNumberConfirmationModal, {
        closeModal: this.props.closeModal,
        trustedNumberAction: this.props.trustedNumberAction,
        modalKey: this.props.modalKey,
        deleteError: this.props.deleteError
      });
    }
    return null;
  }
}
UpdateTrustedNumberModalContainer.propTypes = {
  updateTrustedNumberModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  trustedNumberAction: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  deleteError: PropTypes.bool
};
const mapStateToProps = state => {
  return {
    updateTrustedNumberModalOpen: getIsUpdateTrustedNumberModal(state),
    modalKey: updateTrustedPhoneNumberKey,
    deleteError: undefined
  };
};
export default connect(mapStateToProps, {
  closeModal: toggleUpdateTrustedNumberModal,
  trustedNumberAction: () => setup(true)
})(UpdateTrustedNumberModalContainer);